<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >


  <el-link type="primary">用户APP使用隐私协议</el-link>
  <el-input
    type="textarea"
    placeholder=""
    v-model="xieyineirong"
    maxlength="50000"
    rows="30"
    show-word-limit
  >
  </el-input>
  <el-button type="primary" @click="save_user_yinsixieyi" >保存用户隐私协议</el-button>

  </div>


</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading :false,
      devkindkind:0,
      xieyineirong:"",
      id:0,
      token:"",
    };
  },
  created(){
      this.id     = sessionStorage.getItem("id");
      this.token  = sessionStorage.getItem("token");
      this.get_user_yinsixieyi();
  },
  methods: {
    save_user_yinsixieyi(){
      if(this.xieyineirong.length < 3000){
        return;
      }
      let xieyibase64 = Base64.encode(this.xieyineirong);
      let data = new FormData();
      data.append("id", this.id );
      data.append("token", this.token );
      data.append("xieyi", xieyibase64 );
      axios
      .post("user/fnckukei/save_user_yinsixieyi", data )
      .then(
        function(res) {
           if(res.data.res){
             console.log(res.data);
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    get_user_yinsixieyi(){
      let data = new FormData();
      data.append("id", this.id );
      data.append("token", this.token );
      axios
      .post("user/fnckukei/get_user_yinsixieyi", data )
      .then(
        function(res) {
           if(res.data.res){
             this.xieyineirong = Base64.decode(res.data.data.xieyi );
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/admin_infoconfig.vue